import { useFirestoreNoCompagnyTwo } from '../../firebase/useFirestore';
import { client } from '../../hooks/Client';

const SyncCounter = ({id}) => {

    // Firestore
  const syncs = useFirestoreNoCompagnyTwo('Synchronisations', 'Project', id, 'Parent', client);
  // 'Activity' rows are informational pairing rows (linked-badge source), not data syncs.
  const noEffectSyncs = syncs && syncs.filter(s => s.Type !== 'Effect' && s.Type !== 'Activity' && s.Status !== 'deleted');


  return (
    noEffectSyncs && noEffectSyncs.length
  )
}

export default SyncCounter